import { put } from 'redux-saga/effects';
import { authenticate } from 'auth/actions';
import { insuranceEligibility } from 'app/routes';

export function* insuranceEligibilityNavigate() {
  yield put(
    authenticate(insuranceEligibility())
  );
}
